import React, { useEffect, useState } from 'react';
import { useLevelUpStore } from '../stores/levelUpStore';
import { useUserStore } from '../stores/userStore';
import { DomainLevelUpCelebration } from './DomainLevelUpCelebration';
import { UserLevelUpCelebration } from './UserLevelUpCelebration';
import type { LevelUpQueueItem } from '../stores/levelUpStore';

export function LevelUpCelebrationManager() {
  const { dequeueNext, markCelebrated } = useLevelUpStore();
  const { name, avatarUrl } = useUserStore();
  const [currentCelebration, setCurrentCelebration] = useState<LevelUpQueueItem | null>(null);

  useEffect(() => {
    if (currentCelebration) {
      return;
    }

    const checkQueue = () => {
      const next = dequeueNext();
      if (next) {
        setCurrentCelebration(next);
      }
    };

    checkQueue();

    const interval = setInterval(checkQueue, 500);
    return () => clearInterval(interval);
  }, [currentCelebration, dequeueNext]);

  const handleClose = () => {
    if (currentCelebration) {
      markCelebrated(currentCelebration.id);
      setCurrentCelebration(null);
    }
  };

  if (!currentCelebration) {
    return null;
  }

  const { data } = currentCelebration;

  if (data.type === 'domain') {
    return (
      <DomainLevelUpCelebration
        categoryId={data.categoryId}
        categoryName={data.categoryName}
        categoryColor={data.categoryColor}
        categoryIcon={data.categoryIcon}
        oldLevel={data.oldLevel}
        newLevel={data.newLevel}
        oldTotalLevel={data.oldTotalLevel}
        newTotalLevel={data.newTotalLevel}
        newPoints={data.newPoints}
        onClose={handleClose}
      />
    );
  } else {
    return (
      <UserLevelUpCelebration
        userName={name}
        avatarUrl={avatarUrl}
        oldLevel={data.oldLevel}
        newLevel={data.newLevel}
        oldTotalLevel={data.oldTotalLevel}
        newTotalLevel={data.newTotalLevel}
        newPoints={data.newPoints}
        onClose={handleClose}
      />
    );
  }
}
